import { useState } from "react";

import { Event } from "./Event";
import {
  differenceInMinutes,
  getHours,
  getMinutes,
  isAfter,
  isBefore,
  isSameDay,
  isSameMinute,
} from "date-fns";

export function EventList({ day, eventList, onSelectEventClick }) {
  const [currentlySelectedEventId, setCurrentlySelectedEventId] =
    useState(null);
  const { startHour, events, eventOnClick } = {
    events: eventList,
    startHour: 0,
    eventOnClick: (e) => {
      setCurrentlySelectedEventId(e?.id);
      console.log(e, "eventOnClick");
      onSelectEventClick(e);
    },
  };
  // useCalendarStore(
  //   (state) => ({
  //     startHour: state.startHour,
  //     events: state.events,
  //     eventOnClick: state.onEventClick,
  //   }),

  // );

  return (
    <>
      {events
        .filter((event) => {
          return isSameDay(new Date(event.start_time), day); // Filter all events that are not allDay and that are on the current day
        })
        .map((event, idx, eventsArray) => {
          let width = 90;
          let marginLeft = 0;
          let right = 0;
          let zIndex = 61;

          const eventStart = new Date(event.start_time);
          const eventEnd = new Date(event.end_time);
          const eventDuration = differenceInMinutes(eventEnd, eventStart);

          const eventStartHour = getHours(eventStart);
          const eventStartDiff =
            (eventStartHour - (startHour || 0)) * 60 + getMinutes(startHour);
          const nextEvent = eventsArray[idx + 1];
          const prevEvent = eventsArray[idx - 1];

          // Check for overlapping events since this is sorted it should just work.
          if (nextEvent) {
            const nextEventStart = new Date(nextEvent.start_time);
            const nextEventEnd = new Date(nextEvent.end_time);
            // check if next event starts before this event ends
            if (isBefore(nextEventStart, eventEnd)) {
              // figure out which event has the longest duration
              const nextEventDuration = nextEventEnd.diff(
                nextEventStart,
                "minutes"
              );
              if (nextEventDuration > eventDuration) {
                zIndex = 65;

                marginLeft = "auto";
                // 8 looks like a really random number but we need to take into account the bordersize on the event.
                // Logically it should be 5% but this causes a bit of a overhang which we don't want.
                right = 8;
                width = width / 2;
              }
            }

            if (isSameMinute(nextEventStart, eventStart)) {
              zIndex = 66;

              marginLeft = "auto";
              right = 8;
              width = width / 2;
            }
          } else if (prevEvent) {
            const prevEventStart = new Date(prevEvent.start);
            const prevEventEnd = new Date(prevEvent.end);
            // check if next event starts before this event ends
            if (isAfter(prevEventEnd, eventStart)) {
              // figure out which event has the longest duration
              const prevEventDuration = prevEventEnd.diff(
                prevEventStart,
                "minutes"
              );
              if (prevEventDuration > eventDuration) {
                zIndex = 65;
                marginLeft = "auto";
                right = 8;
                width = width / 2;
                if (eventDuration >= 30) {
                  width = 80;
                }
              }
            }
          }

          return (
            <div
              key={`${event.id}-${eventStart.toISOString()}`}
              className="absolute inset-x-1 "
              style={{
                marginLeft,
                zIndex,
                right: `calc(${right}% - 1px)`,
                width: `${width}%`,
                top: `calc(${eventStartDiff}*var(--one-minute-height))`,
                height: `calc(${eventDuration}*var(--one-minute-height))`,
              }}
            >
              <Event
                event={event}
                eventDuration={eventDuration}
                currentlySelectedEventId={currentlySelectedEventId}
                onEventClick={eventOnClick}
              />
            </div>
          );
        })}
    </>
  );
}
